export default "__VITE_ASSET__D$DAEsmr__"